<div class="row" *ngIf="!loadingComponent && minDate; else loading">
  <div class="col-12 d-none">
    Is Export Customer 2: {{ checkout.extra.isExportCustomer }}<br />
    Is Export Customer VAT: {{ checkout.extra.customerVATCode }}<br />
    <pre> {{ checkout.extra | json }}</pre>
    <br />
  </div>
  <div class="col-12 col-md-6">
    <!-- <div [formGroup]="form">
        <lib-meta-select-input formControlName="levsattkod" table="x2f" metaId="levsattkod" metaDisplay="levsattbeskr">
        </lib-meta-select-input>
      </div> -->
    <div class="form-group" [formGroup]="form">
      <label for="deliveryMethod" class="control-label" translate>DELIVERY_METHOD</label>
      <select
        name="deliveryMethod"
        id="deliveryMethod"
        class="form-control"
        formControlName="levsattkod"
        (change)="calculateFreightCost()"
      >
        <option [value]="entry.id" *ngFor="let entry of deliveryMethodEntries">
          {{ entry.name | translate }}
        </option>
      </select>
    </div>
    <div [formGroup]="form" *ngIf="!isUser && !checkout.extra.isExportCustomer && isTylo">
      <lib-meta-select-input formControlName="levvillkkod" table="x2e" metaId="levvillkkod" metaDisplay="levvillkbeskr">
      </lib-meta-select-input>
    </div>
    <div class="form-group" [formGroup]="form" *ngIf="!isTylo && deliveryTermsEntries">
      <label for="deliveryMethod" class="control-label" translate>DELIVERY_TERMS</label>
      <select
        name="deliveryTerms"
        id="deliveryTerms"
        class="form-control"
        formControlName="levvillkkod"
      >
        <option [value]="entry.id" *ngFor="let entry of deliveryTermsEntries">
          {{ entry.name | translate }}
        </option>
      </select>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div [formGroup]="form" *ngIf="!isUser">
      <lib-meta-select-input formControlName="betkod" table="x2" metaId="betkod" metaDisplay="betvillbeskr">
      </lib-meta-select-input>
    </div>
    <div [formGroup]="form" *ngIf="!isUser">
      <lib-meta-select-input formControlName="saljare" table="salj" metaId="saljare" metaDisplay="saljarenamn">
      </lib-meta-select-input>
    </div>
    <!--
      <div>

        <div class="form-group" [formGroup]="form">
          <label for="partDelivery" class="control-label" translate>PART_DELIVERY</label>
          <select name="partDelivery" id="partDelivery" class="form-control form-select" formControlName="dellevtillaten"
            (change)="handlePartDeliveryChange();">
            <option [value]="entry.id" *ngFor="let entry of partDeliveryEntries">
              {{entry.name | translate}}
            </option>
          </select>
        </div>
      </div>
      <div *ngIf="checkout.extra.oh.dellevtillaten=='10'">
        <lib-delivery-date-picker *ngIf="minDate" (selectedDate)="dateSelected($event)"
          [deliveryMethod]="checkout.extra.procargs.levsattkod" [minInitialDate]="minDate"></lib-delivery-date-picker>
      </div>
      <div *ngIf="shouldFreightBeApplied && form.get('dellevtillaten').value =='0'" translate>
        TYLO_PART_DELIVERY_MESSAGE
      </div>
    -->
  </div>
  <div class="col-12">
    <div *ngIf="alertMessageFreightCost" class="alert mt-2 text-center alert-primary" role="alert">
      <span [innerHTML]="alertMessageFreightCost.message"></span>
    </div>
  </div>

  <!-- NO ADMIN FEES
    <div class="col-12 text-center">
      <div *ngIf="alertMessageAdminFee" class="alert mt-2 text-center alert-{{alertMessageAdminFee.type}}" role="alert">
        {{ alertMessageAdminFee.message | translate }}
      </div>
    </div>
    -->
  <div class="col-6 d-none">
    <pre>{{ checkout.rows | json }}</pre>
  </div>
  <div class="col-6 d-none">
    <pre>{{ checkout.extra | json }}</pre>
  </div>
</div>

<ng-template #loading translate>
  <i class="fa fa-spinner fa-spin fa-7x"></i>
</ng-template>
